import { deepCopy } from "@utils/toolBox";
import { createItem } from "@stores/survey/cardPayloadHandler";
// import { useSurveyCardsStore } from "@stores/survey/surveyCards";
import { updateAnswersFromSourceCard } from "./updateDynamicAnswers";

const findCardByToken = ({ cards, token }) => cards.find((card) => card.token === token);

export const updateItemsFromSourceCard = ({ cards, sourceCardToken, targetCard, recursive = true }) => {
  const sourceCard = findCardByToken({ cards, token: sourceCardToken });
  if (!sourceCard) return;

  if (
    sourceCard.specs.has_dynamic_answers &&
    !sourceCard.specs.dynamic_answers_custom &&
    sourceCard.specs.dynamic_answers_source_question_token &&
    recursive
  ) {
    updateAnswersFromSourceCard({
      cards,
      sourceCardToken: sourceCard.specs.dynamic_answers_source_question_token,
      targetCard: sourceCard,
    });
  }
  const sourceAnswers = sourceCard.specs.answers || [];
  const newItems = sourceAnswers.map((answer, index) => ({
    ...(targetCard.specs.items[index] || createItem(index)),
    token: answer.token,
    code: answer.code,
    title: deepCopy(answer.title),
  }));
  if (JSON.stringify(newItems) !== JSON.stringify(targetCard.specs.items)) targetCard.specs.items = newItems;
};
